import axios from 'axios';
import { generateQueryParams } from 'utils/generateQueryParams';

export const PushNotificationService = {
  async getPushNotifications(page, perPage, filters) {
    const params = generateQueryParams({
      page,
      size: perPage,
      ...filters,
    });

    const res = await axios.get('push_manager/', { params });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getPushNotificationDetails(pushNotificationId) {
    const res = await axios.get(`push_manager/${pushNotificationId}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getStatistics(pushNotificationId) {
    const res = await axios.get(
      `push_manager/statistics/${pushNotificationId}/`
    );

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createPushNotification(data) {
    const res = await axios.post('push_manager/', data);

    if (res.status === 201) {
      return true;
    }

    return Promise.reject();
  },

  async updatePushNotification(pushNotificationId, data) {
    const res = await axios.put(`push_manager/${pushNotificationId}/`, data);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async deletePushNotification(pushNotificationId) {
    const res = await axios.delete(`push_manager/${pushNotificationId}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
};
